import { NgModule } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

@NgModule({
  imports: [TranslateModule],
  exports: [TranslateModule],
})
export class I18nModule {}

export function translateLoaderFactory(httpClient: HttpClient) {
  const dateObject = new Date();
  const currentTimestamp = dateObject.getTime();
  return new TranslateHttpLoader(
    httpClient,
    // Use a relative path so deployments under a sub-path can still load i18n.
    'assets/i18n/',
    `.json?v1=${currentTimestamp}`
  );
}
